export enum MascaraTextoEnum {
  CPF = '000.000.000-00',
  CNPJ = 'NN.NNN.NNN/NNNN-00',
}

export const DEFINICOES_MASCARA_CNPJ = {
  N: /[0-9A-Za-z]/,
};

export const PREPARAR_MAIUSCULO_CNPJ = (valor: string): string =>
  String(valor ?? '').toUpperCase();
